import { useTranslation } from "react-i18next";

interface OverallScoreRingProps {
  percent: number;
  size?: number;
  strokeWidth?: number;
  trackColor?: string;
  progressColor?: string;
}

export const OverallScoreRing = ({
  percent,
  size = 140,
  strokeWidth = 10,
  trackColor = "var(--color-border)",
  progressColor = "var(--color-success)",
}: OverallScoreRingProps) => {
  const { t } = useTranslation(["common"]);
  const center = size / 2;
  const radius = center - strokeWidth / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percent / 100) * circumference;

  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="rotate-180 absolute inset-0"
      >
        {/* Track */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={trackColor}
          strokeWidth={strokeWidth}
        />
        {/* Progress */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={progressColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className="transition-all duration-700"
        />
      </svg>
      {/* Label */}
      <div className="flex flex-col items-center z-10">
        <span className="text-2xl font-bold text-gray-800">{percent}%</span>
        <span className="text-xs text-gray-500">
          {t("common:shared_ui.overall")}
        </span>
      </div>
    </div>
  );
};
